"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _reactMoment = _interopRequireDefault(require("react-moment"));
var _SttContainer = _interopRequireDefault(require("../SttLayout/SttContainer"));
var _SttPaper = _interopRequireDefault(require("../SttSurfaces/SttPaper"));
var _SttHeading = _interopRequireDefault(require("../SttTypography/SttHeading"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _GetApp = _interopRequireDefault(require("@material-ui/icons/GetApp"));
var _core = require("@material-ui/core");
var _Description = _interopRequireDefault(require("@material-ui/icons/Description"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {
      padding: theme.spacing(1, 2, 1, 2),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      borderRadius: theme.spacing(1),
      position: 'relative',
      minWidth: function minWidth(props) {
        return props.minWidth || '10%';
      },
      maxWidth: '70%',
      maxHeight: '550px',
      boxShadow: '0 1px 2px #00000029',
      '&::before': {
        content: "'' ''",
        height: 0,
        position: 'absolute',
        top: '22px',
        width: 0,
        zIndex: 1,
        right: '30px;',
        border: 'medium solid black',
        borderWidth: '10px 0 10px 10px',
        borderColor: 'transparent black transparent transparent'
      },
      backgroundColor: function backgroundColor(props) {
        return props.proprioUsuarioEnvio ? theme.palette.balao_chat.primary : theme.palette.balao_chat_outro.primary;
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
    time: {
      fontSize: '0.8em',
      color: theme.palette.texto_chat.secondary
    },
    name: {
      fontWeight: 600,
      color: theme.palette.indicacao_fala_usuario.primary
    },
    message: {
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
      color: theme.palette.texto_chat.primary
    },
    image: {
      objectFit: 'contain',
      maxWidth: '100%',
      cursor: 'pointer',
      maxHeight: '515px'
    },
    containerImage: {
      maxWidth: '620px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    },
    iconButton: {
      minWidth: '40px'
    }
  };
});
function SttMensagemAnexo(props) {
  var classes = useStyles(props);
  var timestamp = props.timestamp,
    usuario = props.usuario,
    url = props.url,
    imagem = props.imagem,
    nome = props.nome,
    proprioUsuarioEnvio = props.proprioUsuarioEnvio,
    esconderNomeEnviador = props.esconderNomeEnviador,
    strings = props.strings;
  var containerStyles = {};
  if (proprioUsuarioEnvio) {
    containerStyles.alignItems = 'flex-end';
  }
  return /*#__PURE__*/_react["default"].createElement(_SttContainer["default"], {
    className: classes.container,
    style: containerStyles,
    maxWidth: "xl"
  }, /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
    className: classes.card
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    className: classes.name,
    gutterBottom: true,
    variant: "h5"
  }, esconderNomeEnviador || proprioUsuarioEnvio ? '' : usuario.nome), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return window.open(url, '_blank');
    }
  }, imagem ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.containerImage
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    className: classes.image
  })) : /*#__PURE__*/_react["default"].createElement(_core.List, {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, {
    style: {
      minWidth: '40px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Description["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h5"
    }, " ", nome)
  })), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: strings.download
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    disableRipple: true,
    edge: "end",
    className: classes.iconButton
  }, /*#__PURE__*/_react["default"].createElement(_GetApp["default"], null)))), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    align: "right",
    className: classes.time
  }, /*#__PURE__*/_react["default"].createElement(_reactMoment["default"], {
    format: "HH:mm"
  }, timestamp))));
}
var _default = SttMensagemAnexo;
exports["default"] = _default;